import script from "./new-remark-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./new-remark-button.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__